/* global attachEvent,localData */

// *******************************************************************************
// 1.0 - Tab Login Popup
// *******************************************************************************

window.addEventListener('load', () => {
  const navTabLink = document.querySelectorAll('[data-tablink]');

  // Close tab content
  const closeTabContents = (tabNavParent) => {
    const tabContentElems = tabNavParent.querySelectorAll('[data-tab-content]');
    navTabLink.forEach((elem) => {
      elem.classList.remove('is-active');
    });
    tabContentElems.forEach((contentElem) => {
      contentElem.classList.remove('is-active');
    });
  };

  // Open specific tab
  navTabLink.forEach((el, index) => {
    el.addEventListener('click', () => {
      const tabNavParent = el.closest('[data-tab]');
      const tabContentWrapper = tabNavParent.querySelector('[data-tab-wrapper]');
      const targetTabContent = tabContentWrapper.querySelectorAll('[data-tab-content]')[index];
      closeTabContents(tabNavParent);
      setTimeout(() => {
        targetTabContent.classList.add('is-active');
      }, 100);
      el.classList.add('is-active');
    });
  });
});

// *******************************************************************************
// 2.0 - Close Login Popup
// *******************************************************************************

attachEvent('.login-popup__close', 'click', (ev) => {
  document.body.classList.remove('is-open-modal');
  ev.preventDefault();
});

if (document.querySelector('.sc-login')) {
  const loginForm = (() => {
    const r = {
      signUp: document.querySelector('.sc-login'),
      buttons: document.querySelectorAll('.sc-login .btn--submit'),
      loading: false,
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        r.signUp.querySelectorAll('.tab-content.is-active input').forEach((input) => {
          const type = input.getAttribute('type');
          switch (type) {
            case 'checkbox':
              formData[input.name] = input.checked;
              if (typeof input.getAttribute('required') === 'string' && !input.checked) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!/^[\w\d._-]+@[\w\d\-_.]+\.[\d\w][\d\w]+$/.test(formData[input.name])) {
                  input.closest('div').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('div').classList.remove('is-validation-failed');
                }
              }
              break;
            case 'password':
              formData[input.name] = input.value.trim();
              if (!formData[input.name]
                || (input.value.trim().length < 6 && input.value.trim().length > 0)) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            case 'hidden':
            case 'text':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            default:
          }
        });
        if (r.isValid && !r.loading) {
          document.querySelector('.tab-content.is-active .modal-warning-text').hidden = true;
          r.loading = true;
          const ajax = new XMLHttpRequest();
          const formInfo = new FormData();
          Object.keys(formData).forEach((key) => {
            formInfo.append(key, formData[key]);
          });
          formInfo.append('id', localData.id);
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            if (response.data.status === 200 && response.data.url) {
              window.location = response.data.url;
            } else if (response.data.status === 200) {
              document.querySelector('.tab-content.is-active form').innerHTML = response.data.message;
            } else {
              document.querySelector('.tab-content.is-active .modal-warning-text').hidden = false;
              document.querySelector('.tab-content.is-active .modal-warning-text h3').innerHTML = response.data.message;
            }
            r.loading = false;
          };
          ajax.send(formInfo);
        }
      },
      initButton: () => {
        r.buttons.forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            r.sendAjax();
          });
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
      },
    };
  })();
  loginForm.initialize();
}
